import { SystemIcons } from '@almbrand/systemicons';
import classNames from 'classnames';
import styles from './ResultBox.module.scss';

export interface ResultBoxProps {
	header: string;
	subHeader: string;
}

export const ResultBox: React.FC<ResultBoxProps> = ({ header, subHeader }) => {
	return (
		<div className={classNames(styles.ResultBox)}>
			<div className={classNames(styles.ResultBox__leftContent)}>
				<div className={classNames(styles.ResultBox__header)}>{header}</div>
				<div className={classNames(styles.ResultBox__subHeader)}>{subHeader}</div>
			</div>
			<div className={classNames(styles.ResultBox__rightContent)}>
				<SystemIcons
					height={40}
					width={40}
					themeName={'Codan-theme'}
					icon={'car'}
				/>
			</div>
		</div>
	);
};
